import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../api/api';
import { AlertType, Modes, User } from '../types/common';
import { Plan } from '../types/billing';
import { showAlert } from './CommonSlice';
import { AUTH_API } from '../api/amplify';

const NOT_AUTHORIZATED_STATUS = 401;

type UserState = {
  user: User | null;
  modes: Modes;
  plans: Plan[];
};

const initialState: UserState = {
  user: null,
  modes: [],
  plans: [],
};

export const initUser = createAsyncThunk('user/initUser', async (_, { dispatch }) => {
  try {
    const user = await API.getUser();

    dispatch(setUser(user));
    return user;
  } catch (e: any) {
    if (e?.status === NOT_AUTHORIZATED_STATUS) {
      await AUTH_API.signOut();
      return;
    }

    if (e?.status === 404) {
      try {
        const user = await API.createUser();
        dispatch(setUser(user));
        return user;
      } catch (e: any) {
        console.log('initUser slice error:', e);
        dispatch(
          showAlert({
            type: AlertType.Error,
            message: 'Произошла ошибка при загрузке юзера',
          })
        );
        return Promise.reject(e);
      }
    }
    return Promise.reject(e);
  }
});

export const getModes = createAsyncThunk('user/getModes', async (_, { dispatch }) => {
  try {
    const modes = await API.getModes();
    dispatch(setModes(modes));
  } catch (e: any) {
    dispatch(
      showAlert({
        type: AlertType.Error,
        message: 'Произошла ошибка при шаблонов',
      })
    );
    console.log('error:', e);
  }
});

export const getPlans = createAsyncThunk('user/getPlans', async (_, { dispatch }) => {
  try {
    const plans = await API.getPlans();
    dispatch(setPlans(plans));
  } catch (e: any) {
    dispatch(
      showAlert({
        type: AlertType.Error,
        message: 'Произошла ошибка при загрузке планов',
      })
    );
    console.log('error:', e);
  }
});

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, { payload }) => {
      if (payload.free_tier) {
        // const availableGenerations = (payload.free_tier.availableGenerations =
        //   (payload.credits.total - payload.credits.used) +
        //   payload.free_tier.total_generations - (payload?.free_tier.used_generations ?? 0));
        const user = {
          ...payload,
          free_tier: {
            ...payload.free_tier,
            // availableGenerations,
          },
        };
        state.user = user;
        return;
      }

      state.user = payload;
    },

    setModes: (state, { payload }) => {
      state.modes = payload;
    },

    setPlans: (state, { payload }) => {
      state.plans = payload;
    },

    // setFreeAvailableGenerations: (state, { payload }) => {
    //   if (!state.user) return;
    //   state.user.free_tier.availableGenerations = payload;
    // },
  },
});

// export const { setUser, setModes, setPlans, setFreeAvailableGenerations } = userSlice.actions;
export const { setUser, setModes, setPlans } = userSlice.actions;

export default userSlice.reducer;
